import React, { useState } from "react"

const IntegrationFaq: React.FC = () => {

    // Accordion Active Index
    const [active, setActive] = useState<number>(1);

    const toggleAccordion = (index: number) => {
        setActive(active === index ? -1 : index);
    };

    const faqItems = [
        {
            id: 1,
            title: "01. System Assessment",
            content:
                "Analyze your existing systems, workflows, and data to identify integration opportunities.",
        },
        {
            id: 2,
            title: "02. Integration Design",
            content:
                "Plan and design AI solutions that connect seamlessly with your platforms and processes.",
        },
        {
            id: 3,
            title: "03. Implement and Deploy",
            content:
                "Integrate AI tools into your systems, automate workflows, and ensure smooth operation.",
        },
        {
            id: 4,
            title: "04. Monitor and Optimize",
            content:
                "Track performance, refine integrations, and continuously improve efficiency and results.",
        },
    ];


    return (
            <div className="service-process-wrap pt-120 pb-125">
                <div className="row mt-none-50 align-items-center">
                    {/* LEFT SIDE ACCORDION */}
                    <div className="col-lg-6 mt-50">
                        <h2 className="details-content-title mb-40">From Systems to Insights</h2>

                        <div className="service_process_faq">
                            <div className="accordion">
                                {faqItems.map((item) => (
                                    <div className="accordion-item" key={item.id}>
                                        <div
                                            className={`accordion-button ${active === item.id ? "" : "collapsed"
                                                }`}
                                            role="button"
                                            onClick={() => toggleAccordion(item.id)}
                                        >
                                            {item.title}
                                        </div>

                                        <div
                                            className={`accordion-collapse collapse ${active === item.id ? "show" : ""
                                                }`}
                                        >
                                            <div className="accordion-body">
                                                <p className="m-0">{item.content}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE CLICKABLE LIST */}
                    <div className="col-lg-6 mt-50">
                        <ul className="content_layer_group list-unstyled">
                            {faqItems.map((item) => (
                                <li
                                    key={item.id}
                                    onClick={() => toggleAccordion(item.id)}
                                    className={active === item.id ? "active" : ""}
                                >
                                    <span>{item.title.replace(/^\d+\.\s/, "")}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
    )
}

export default IntegrationFaq;